import { List, Home, Users, Lock, DollarSign, Loader, UploadCloud, CloudLightning, Send } from "react-feather";

export const MENUITEMS = [
  {
    title: "Dashboard",
    icon: Home,
    path: "/dashboard",
    type: "link",
    badgeType: "primary",
    active: false,
    show: true,
  },
  {
    title: "Address",
    icon: List,
    path: "/dashboard/admin",
    type: "link",
    badgeType: "primary",
    active: false,
    show: true,
  },
  {
    title: "Users",
    icon: Users,
    path: "/dashboard/users",
    type: "link",
    badgeType: "primary",
    active: false,
    show: true,
  },
  {
    title: "Rewards",
    icon: DollarSign,
    path: "/dashboard/rewards",
    type: "link",
    badgeType: "primary",
    active: false,
    show: true,
  },
  {
    title: "Reward Logs",
    icon: Loader,
    path: "/dashboard/logs",
    type: "link",
    badgeType: "primary",
    active: false,
    show: true,
  },
  {
    title: "CSV Upload",
    icon: UploadCloud,
    path: "/dashboard/csv",
    type: "link",
    badgeType: "primary",
    active: false,
    show: true,
  },
  {
    title: "Distribute",
    icon: Send,
    path: "/dashboard/distribute",
    type: "link",
    badgeType: "primary",
    active: false,
    show: true,
  },
  {
    title: "Luminous Rewards",
    icon: CloudLightning,
    path: "/dashboard/luminous",
    type: "link",
    badgeType: "primary",
    active: false,
    show: true,
  },
  {
    title: "2FA",
    icon: Lock,
    path: "/dashboard/security",
    type: "link",
    badgeType: "primary",
    active: false,
    show: true,
  },
];
